export const ENDPOINTS = {
    ACCEPT_TERMS: "/nucleus-nuclear/nui/nbs/acceptTerms",
    AD_HOC_FEE_AUTH: "/nucleus-nuclear/nui/nsbs/adHocFeeAuth",
    CHANGE_PASSWORD: "/nucleus-nuclear/nui/nbs/changePassword",
    CLIENT_PREFERENCES: "/nucleus-nuclear/nui/nsbs/clientPreferences",
    CORRESPONDENCES: "/nucleus-nuclear/nui/nsbs/correspondences",
    CORRESPONDENCE_DELIVERY_PREFERENCE:
        "/nucleus-nuclear/nui/nsbs/correspondenceDeliveryPreference",
    CORRESPONDENCE_DELIVERY_OPTIONS: "/nucleus-nuclear/nui/nsbs/correspondenceDeliveryOptions",
    KEEP_ALIVE: "/nucleus-nuclear/nui/public/keepalive",
    LOGIN: "/nucleus-nuclear/nui/login",
    LOGOUT: "/nucleus-nuclear/nui/public/logout",
    MARK_AS_READ: "/nucleus-nuclear/nui/nsbs/correspondence/markAsRead",
    NEW_PASSWORD: "/nucleus-nuclear/nui/public/newPassword",
    NEWS_FEED: "/nucleus-nuclear/nui/nbs/newsFeed",
    REGISTER: "/nucleus-nuclear/nui/public/register",
    RESET_PASSWORD: "/nucleus-nuclear/nui/public/reset",
    IMPERSONATE_USER: "/nucleus-nuclear/nui/nbs/impersonateUser",
    STOP_IMPERSONATING_CLIENT: "/nucleus-nuclear/nui/nbs/stopImpersonation",
    SYSTEM_STATUS: "/nucleus-nuclear/nui/public/sonataNRTStatus"
};
